import {
  CredentialLayoutBox,
  CredentialSearchbar,
  SkillSearchBar,
} from '../../../components';
import React, { useContext, useEffect, useState } from 'react';
import {
  api,
  getImageUrl,
  getTenant,
  GLOBAL_COLORS,
  useProfileCredentials,
  useProfileSkills,
} from '../../../hooks';
import { Account } from '../../../components/account';
import { AppDataContext } from '../../../utils/context';
import { ICredential, IUserData, IUserMetaData } from '../../../model';
import './PublicProfileContentView.css';
import { FaFacebookF, FaShareAlt } from 'react-icons/fa';
import { LuPencil } from 'react-icons/lu';
import { FaLinkedinIn, FaXTwitter } from 'react-icons/fa6';
import { SkillSection } from '../../../components/SkillSection';
import { AddSkillButton } from '../AddSkillButton';
import { inIframe } from '../../../utils';

export const PublicProfileContentView = ({ username }) => {
  const { appData, setAppData } = useContext<any>(AppDataContext);
  const [
    userEarnedSkillsData,
    userEarnedSkillsDataLoaded,
    highlightedSkillsData,
    highlightedSkillsDataLoaded,
    userSelfReportedSkillsData,
    userSelfReportedSkillsDataLoaded,
    setUserSelfReportedSkillsData,
    setHighlightedSkillsData,
  ] = useProfileSkills(username, getTenant());
  const [searchTerm, setSearchTerm] = useState('');

  const [facebookUrl, setFacebookUrl] = useState('');
  const [linkedinUrl, setLinkedinUrl] = useState('');
  const [twitterUrl, setTwitterUrl] = useState('');
  const [socialEnabled, setSocialEnabled] = useState(true);

  const [
    userCredentials,
    userCredentialsLoaded,
    discoverCredentials,
    discoverCredentialsLoaded,
  ] = useProfileCredentials(username);
  const [userMetaData, setUserMetaData] = useState<IUserMetaData>(
    inIframe()
      ? null
      : {
          ...appData.userMetaData,
        }
  );
  const [userMetaDataLoaded, setUserMetaDataLoaded] = useState<boolean>(
    inIframe() ? false : appData.userMetaDataLoaded
  );
  const [isFocused, setIsFocused] = useState(false);

  const handleProfileClick = () => {
    setIsFocused(!isFocused);
  };
  useEffect(() => {
    if (!userMetaData?.name) {
      api.ibledxusers.getUsersManageMetadata({ username }, function (data) {
        setUserMetaData(data);
        setUserMetaDataLoaded(true);
      });
    }
    setAppData({
      ...appData,
      userCredentials: userCredentials as ICredential[],
      userCredentialsLoaded: userCredentialsLoaded as boolean,
    });
  }, [userCredentialsLoaded]);
  useEffect(() => {
    setUserMetaData(appData.userMetaData);
  }, [appData.userMetaData]);

  const populateSocialMediaLinks = () => {
    const socialLinks = userMetaData?.social_links;
    if (Array.isArray(socialLinks) && socialLinks?.length > 0) {
      socialLinks.forEach(function (socialLink) {
        if (
          !socialLink?.social_link ||
          socialLink?.social_link === '' ||
          socialLink?.social_link === '#'
        ) {
          return;
        }
        const platform = socialLink?.platform;

        if (platform === 'linkedin') {
          setLinkedinUrl('https://linkedin.com/in/' + socialLink?.social_link);
        }
        if (platform === 'twitter') {
          setTwitterUrl('https://twitter.com/' + socialLink?.social_link);
        }

        if (platform === 'facebook') {
          setFacebookUrl('https://www.facebook.com/' + socialLink?.social_link);
        }
      });
    } else {
      setSocialEnabled(false);
    }
  };

  useEffect(() => {
    if (userMetaDataLoaded) {
      populateSocialMediaLinks();
    }
  }, [userMetaDataLoaded, userMetaData]);
  return (
    <span>
      <div
        data-name="pp"
        className="ov_panel active"
        style={{ marginTop: '20px' }}
      >
        <div  className="div-block-518">
          <div className="div-block-445">
            <img
              className="image-150"
              src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab7e_shapelined-_JBKdviweXI-unsplash.jpg"
              alt=""
              sizes="(max-width: 479px) 100vw, (max-width: 767px) 75vw, (max-width: 991px) 77vw, (max-width: 1279px) 100vw, 1054px"
              prop-attr-names="src"
              prop-attr-value-src="banner"
              loading="lazy"
              srcSet="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab7e_shapelined-_JBKdviweXI-unsplash-p-500.jpeg 500w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab7e_shapelined-_JBKdviweXI-unsplash-p-800.jpeg 800w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab7e_shapelined-_JBKdviweXI-unsplash-p-1080.jpeg 1080w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab7e_shapelined-_JBKdviweXI-unsplash-p-1600.jpeg 1600w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab7e_shapelined-_JBKdviweXI-unsplash-p-2000.jpeg 2000w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab7e_shapelined-_JBKdviweXI-unsplash.jpg 2400w"
            />
          </div>
          <div className="div-block-401">
            <div
              data-w-id="f31e1962-462b-8b0d-0045-72a4bb836cf9"
              onClick={handleProfileClick}
              className="div-block-471 edit_profile_trigger"
            >
              <LuPencil
                color={GLOBAL_COLORS.icon_color}
                className={'image-140 public-profile-icon-img'}
              />

            </div>
            <div className="div-block-427">
              <div>
                <div className="div-block-516">
                  <div className="div-block-384">
                    <img
                      src={getImageUrl(
                        userMetaData?.profile_image?.image_url_full
                      )}
                      loading="lazy"
                      prop-attr-names="src"
                      prop-attr-value-src="photo"
                      alt=""
                      className="image-174"
                    />
                  </div>
                </div>
                <div>
                  <strong
                    prop-data-value-fullname=""
                    prop-data-names="fullname"
                    className="bold-text-5"
                  >
                    {userMetaData?.name || ''}
                  </strong>
                </div>
                <div
                  prop-data-value-about="Manual Testing Engineer @ NVIDIA"
                  prop-data-names="about"
                >
                  {userMetaData?.bio || ''}
                </div>
                <div className="followers_text pp">
                  <div
                    data-name="followers"
                    data-w-id="f31e1962-462b-8b0d-0045-72a4bb836d07"
                    className="text-block-226 show_social followers"
                  >
                    120 Following{' '}
                  </div>
                  <div
                    data-name="following"
                    data-w-id="f31e1962-462b-8b0d-0045-72a4bb836d09"
                    className="text-block-226 show_social following"
                  >
                    105 Followers
                  </div>
                </div>

                <div className="div-block-513 pp up">
                  <div className="ed_row">
                    <div className="div-block-495">
                      <div className="div-block-522">
                        <img
                          src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab72_Nvidia_logo.svg.png"
                          loading="lazy"
                          sizes="(max-width: 479px) 26px, 100vw"
                          srcSet="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab72_Nvidia_logo.svg-p-500.png 500w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab72_Nvidia_logo.svg-p-800.png 800w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab72_Nvidia_logo.svg-p-1080.png 1080w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab72_Nvidia_logo.svg.png 1200w"
                          alt=""
                          className="image-162"
                        />
                      </div>
                    </div>
                    <div className="text-block-282">NVIDIA</div>
                  </div>
                  <div className="ed_row last">
                    <div className="div-block-522">
                      <img
                        src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab6d_1280px-MIT_logo.svg.png"
                        loading="lazy"
                        sizes="(max-width: 479px) 26px, 100vw"
                        srcSet="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab6d_1280px-MIT_logo.svg-p-500.png 500w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab6d_1280px-MIT_logo.svg-p-800.png 800w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab6d_1280px-MIT_logo.svg-p-1080.png 1080w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab6d_1280px-MIT_logo.svg.png 1280w"
                        alt=""
                        className="image-162"
                      />
                    </div>
                    <div className="text-block-282">
                      <strong className="bold-text">
                        Massachusetts Institute of Technology
                      </strong>
                    </div>
                  </div>
                </div>
                {!!socialEnabled && (
                  <div className="div-block-408 pp">
                    <a
                      no-mapping=""
                      data-w-id="f31e1962-462b-8b0d-0045-72a4bb836d19"
                      href="#"
                      className="link-block-26 pp w-inline-block"
                    >
                      <FaShareAlt
                        className={'image-149 public-profile-icon-img'}
                        color={GLOBAL_COLORS.icon_color}
                      />
                    </a>
                    {!['', '#'].includes(facebookUrl) && (
                      <a
                        data-w-id="f31e1962-462b-8b0d-0045-72a4bb836d1c"
                        href={facebookUrl}
                        target="_blank"
                        className="link-block-26 pp w-inline-block"
                      >
                        <FaFacebookF
                          className={'image-149 public-profile-icon-img'}
                          color={GLOBAL_COLORS.icon_color}
                        />
                      </a>
                    )}
                    {!['', '#'].includes(linkedinUrl) && (
                      <a
                        data-w-id="f31e1962-462b-8b0d-0045-72a4bb836d1f"
                        href={linkedinUrl}
                        target="_blank"
                        className="link-block-26 pp w-inline-block"
                      >
                        <FaLinkedinIn
                          className={'image-149 public-profile-icon-img'}
                          color={GLOBAL_COLORS.icon_color}
                        />
                      </a>
                    )}
                    {!['', '#'].includes(twitterUrl) && (
                      <a
                        data-w-id="f31e1962-462b-8b0d-0045-72a4bb836d22"
                        href={twitterUrl}
                        target="_blank"
                        className="link-block-26 pp w-inline-block"
                      >
                        <FaXTwitter
                          className={'image-149 public-profile-icon-img'}
                          color={GLOBAL_COLORS.icon_color}
                        />
                      </a>
                    )}
                  </div>
                )}
              </div>
              <div className="div-block-513 pp">
                <div className="ed_row hidden">
                  <div className="div-block-495">
                    <div className="div-block-522">
                      <img
                        src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab72_Nvidia_logo.svg.png"
                        loading="lazy"
                        sizes="100vw"
                        srcSet="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab72_Nvidia_logo.svg-p-500.png 500w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab72_Nvidia_logo.svg-p-800.png 800w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab72_Nvidia_logo.svg-p-1080.png 1080w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab72_Nvidia_logo.svg.png 1200w"
                        alt=""
                        className="image-162"
                      />
                    </div>
                  </div>
                  <div className="text-block-282">NVIDIA</div>
                </div>
                <div className="ed_row last hidden">
                  <div className="div-block-522">
                    <img
                      src="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab6d_1280px-MIT_logo.svg.png"
                      loading="lazy"
                      sizes="100vw"
                      srcSet="https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab6d_1280px-MIT_logo.svg-p-500.png 500w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab6d_1280px-MIT_logo.svg-p-800.png 800w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab6d_1280px-MIT_logo.svg-p-1080.png 1080w, https://assets-global.website-files.com/6596e21ac435cac3c66baad8/6596e21ac435cac3c66bab6d_1280px-MIT_logo.svg.png 1280w"
                      alt=""
                      className="image-162"
                    />
                  </div>
                  <div className="text-block-282">
                    <strong className="bold-text">
                      Massachusetts Institute of Technology
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="div-block-502">
          <div className="text-block-272 pr_t">About</div>
          <div
            prop-data-value-about="Experienced Data Scientist and DevOps Engineer with a demonstrated history of working in the telecommunications industry. Strong engineering professional skilled in Python, Ansible, Linux, Shell Scripting and other related technologies.#python, #ansible, #automation, #flask, #microservices, #datascientist, #linux"
            prop-data-names="about"
            className="text-block-298"
          >
            {userMetaData?.about || ''}
          </div>
        </div>

        <div className="div-block-502">
          <div className="text-block-272 pr_t">Skills</div>
          <div>
            <div className="w-layout-hflex flex-block-22"></div>
            <div className="profile-panels">
              <div
                className="ov_panel active"
                data-name="skills"
                style={{ marginTop: '20px' }}
              >
                <SkillSearchBar
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                />
                <SkillSection
                  title="Earned Skills"
                  skillsData={userEarnedSkillsData}
                  skillsDataLoaded={userEarnedSkillsDataLoaded}
                  refreshSkills={() => {}}
                  searchTerm={searchTerm}
                  noSkillsMessage="You don't have any earned skills yet."
                />
                <div>
                  {userSelfReportedSkillsDataLoaded && (
                    <AddSkillButton
                      skillType="selfReported"
                      skillsData={userSelfReportedSkillsData}
                      refreshSkills={setUserSelfReportedSkillsData}
                    />
                  )}

                  <SkillSection
                    title="Self-Reported"
                    skillsData={userSelfReportedSkillsData}
                    skillsDataLoaded={userSelfReportedSkillsDataLoaded}
                    refreshSkills={setUserSelfReportedSkillsData}
                    searchTerm={searchTerm}
                    noSkillsMessage="You don't have any self-reported skills yet."
                  />
                </div>

                <div>
                  {highlightedSkillsDataLoaded && (
                    <AddSkillButton
                      skillType="highlighted"
                      skillsData={highlightedSkillsData}
                      refreshSkills={setHighlightedSkillsData}
                    />
                  )}
                  <SkillSection
                    title="Desired"
                    skillsData={highlightedSkillsData}
                    skillsDataLoaded={highlightedSkillsDataLoaded}
                    refreshSkills={setHighlightedSkillsData}
                    searchTerm={searchTerm}
                    noSkillsMessage="You don't have any desired skills yet."
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="div-block-502">
          <div className="text-block-272 pr_t">Credentials</div>
          <div>
            <div className="w-layout-hflex flex-block-22"></div>
            <div className="profile-panels">
              <div className="ov_panel active" data-name="credentials">
                <div>
                  <div className="form-block-15 w-form">
                    <CredentialSearchbar></CredentialSearchbar>
                  </div>

                  <CredentialLayoutBox
                    userCredentials={userCredentials as ICredential[]}
                    userCredentialsLoaded={userCredentialsLoaded as boolean}
                    discoverCredentials={discoverCredentials as ICredential[]}
                    discoverCredentialsLoaded={
                      discoverCredentialsLoaded as boolean
                    }
                  ></CredentialLayoutBox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isFocused && <Account onModalClose={() => setIsFocused(false)} />}
    </span>
  );
};
